import React from "react";
import { FaTimes, FaEnvelope, FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import "./Contact.css";

const Contact = ({ onClose }) => {
  return (
    <aside className="contact-panel">
      <button className="close-button" onClick={onClose}>
        <FaTimes />
      </button>
      <div className="contact-content">
        <img src="/logo-n.webp" alt="Logo" className="contact-logo" />
        <h2>Contacto</h2>
        <p>
          Para mayor información o consultas, contáctanos a través de los siguientes medios:
        </p>
        <ul className="contact-details">
          <li>
            <FaEnvelope className="contact-icon" />
            <a href="mailto:noble94fm@gmail.com">noble94fm@gmail.com</a>
          </li>
          <li>
            <FaEnvelope className="contact-icon" />
            <a href="mailto:radioplenitudtotal@gmail.com">radioplenitudtotal@gmail.com</a>
          </li>
          <li>
            <FaPhone className="contact-icon" />
            <a href="tel:8094272330">809-427-2330</a>
          </li>
          <li>
            <FaPhone className="contact-icon" />
            <a href="tel:8492613768">849-261-3768</a>
          </li>
        </ul>
        <p>
          <FaMapMarkerAlt className="contact-icon" />
          Ubicación: Centro del municipio de Vicente Noble, República Dominicana.
        </p>
      </div>
    </aside>
  );
};

export default Contact;
